import axios from "axios";
import consts from "../consts";
import { setErroAPI, setSuccess } from "../common/toast/toast";

export function setFiltro(filtro) {
    return {
        type: "DASHBOARD_FILTRO",
        payload: filtro,
    };
}

export function getListaCliente(idEmpresa) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "DASHBOARD_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora(idEmpresa) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "DASHBOARD_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaDemandaContratoTipo() {
    const request = axios.get(`${consts.API_URL}/demandaContratoTipo/listarselect`);
    return {
        type: "DASHBOARD_CONTRATO_DEMANDA_TIPO_SELECT_LISTADO",
        payload: request,
    };
}

export function getDemanda() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "DASHBOARD_DEMANDA_LISTADO",
                payload: null,
            });

            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().dashboard.filtro.id_cliente || 0}&id_tipo_contrato_demanda=${
                    getState().dashboard.filtro.id_tipo_contrato_demanda || 0
                }&id_unidade_consumidora=${getState().dashboard.filtro.id_unidade_consumidora || 0}&encerrado=false`
            );
            dispatch({
                type: "DASHBOARD_DEMANDA_LISTADO",
                payload: {
                    demandas: resp.data,
                    vigente: resp.data[0],
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getDemandaContagem(callback) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : null;
            const tipoContrato = getState().dashboard.filtro.id_tipo_contrato_demanda || 0;

            dispatch({
                type: "DASHBOARD_DEMANDA_CONTAGEM_LISTADO",
                payload: { data: [] },
            });
            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato/listarContagemComAgendamentoDemanda?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_tipo_contrato_demanda=${tipoContrato}`
            );

            dispatch({
                type: "DASHBOARD_DEMANDA_CONTAGEM_LISTADO",
                payload: resp,
            });
            if (callback) {
                callback();
            }
        } catch (erro) {
            console.error(erro);
            setErroAPI(erro);
        }
    };
}

export function excluirAgendamento({ id, competencia_agendamento, callback }) {
    return (dispatch, getState) => {
        if (window.confirm(`Deseja realmente excluir o agendamento de ${competencia_agendamento}?`)) {
            axios
                .delete(`${consts.API_URL}/demandaAgendamento?id=${id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    if (callback) {
                        callback();
                    }
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
    };
}

export function excluirPeriodoTeste({ id, callback }) {
    return (dispatch, getState) => {
        if (window.confirm(`Deseja realmente excluir o período de teste?`)) {
            axios
                .delete(`${consts.API_URL}/demandaContrato/periodoTeste/?id=${id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    if (callback) {
                        callback();
                    }
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: "DASHBOARD_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function carregarGraficos() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const state = getState();
            dispatch([
                {
                    type: "DASHBOARD_SET_AGUARDANDO",
                    payload: true,
                },
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_ANUAL_LISTADO",
                    payload: [],
                },
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_UNIDADE_ULTIMO_MES_LISTADO",
                    payload: [],
                },
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_UNIDADE_ACUMULADO_ANO_LISTADO",
                    payload: [],
                },
                {
                    type: "DASHBOARD_GRAFICO_CONSUMO_PERCENTUAL_POR_HORARIO_MES_LISTADO",
                    payload: [],
                },
            ]);

            const [listaGraficoCustoAnual, listaGraficoCustoPorUnidadeUltimoMes, listaGraficoCustoPorUnidadeAcumuladoAno, listaConsumoPercentualPorHorarioUltimoMes] =
                await Promise.all([
                    getListaGraficoCustoAnual(state),
                    getListaGraficoCustoPorUnidadeUltimoMes(state),
                    getListaGraficoCustoPorUnidadeAcumuladoAno(state),
                    getListaConsumoPercentualPorHorarioUltimoMes(state),
                ]);

            const competenciaFiltro = getCompetenciaFiltrada(state);

            dispatch([
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_ANUAL_LISTADO",
                    payload: listaGraficoCustoAnual,
                },
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_UNIDADE_ULTIMO_MES_LISTADO",
                    payload: listaGraficoCustoPorUnidadeUltimoMes,
                },
                {
                    type: "DASHBOARD_GRAFICO_CUSTO_UNIDADE_ACUMULADO_ANO_LISTADO",
                    payload: listaGraficoCustoPorUnidadeAcumuladoAno.filter((item) => !item.competencia_desligamento || item.competencia_desligamento >= competenciaFiltro),
                },
                {
                    type: "DASHBOARD_GRAFICO_CONSUMO_PERCENTUAL_POR_HORARIO_MES_LISTADO",
                    payload: listaConsumoPercentualPorHorarioUltimoMes,
                },
                {
                    type: "DASHBOARD_SET_AGUARDANDO",
                    payload: false,
                },
            ]);
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

async function getListaGraficoCustoAnual(state) {
    try {
        const usuarioLogado = state.auth.usuarioLogado;
        const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.dashboard.filtro.id_cliente || null;
        const resp = await axios.get(
            `${consts.API_URL}/fatura/listarGraficoCusto?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${
                state.dashboard.filtro.id_unidade_consumidora || null
            }`
        );
        return resp.data;
    } catch (erro) {
        setErroAPI(erro);
    }
}

function getCompetenciaFiltrada(state) {
    let competenciaBase = "";
    let dataAtual = new Date();
    if (state.dashboard.filtro.mes_base == 2) {
        dataAtual.setMonth(dataAtual.getMonth() - 2);
        competenciaBase = parseInt(`${dataAtual.getFullYear()}${dataAtual.getMonth() < 9 ? "0" : ""}${dataAtual.getMonth() + 1}`);
    } else {
        dataAtual.setMonth(dataAtual.getMonth() - 1);
        competenciaBase = parseInt(`${dataAtual.getFullYear()}${dataAtual.getMonth() < 9 ? "0" : ""}${dataAtual.getMonth() + 1}`);
    }
    return competenciaBase;
}

async function getListaGraficoCustoPorUnidadeUltimoMes(state) {
    try {
        const usuarioLogado = state.auth.usuarioLogado;
        let competenciaBase = getCompetenciaFiltrada(state);
        let competenciaBaseParam = competenciaBase ? `&competencia_base=${competenciaBase}` : "";

        const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.dashboard.filtro.id_cliente || 0;
        const resp = await axios.get(
            `${consts.API_URL}/fatura/listarGraficoCustoPorUnidadeUltimoMes?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}${competenciaBaseParam}`
        );
        return resp.data;
    } catch (erro) {
        setErroAPI(erro);
    }
}

async function getListaGraficoCustoPorUnidadeAcumuladoAno(state) {
    try {
        const usuarioLogado = state.auth.usuarioLogado;

        const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.dashboard.filtro.id_cliente || 0;
        const resp = await axios.get(`${consts.API_URL}/fatura/listarGraficoCustoPorUnidadeAcumuladoAno?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}`);
        return resp.data;
    } catch (erro) {
        setErroAPI(erro);
    }
}

async function getListaConsumoPercentualPorHorarioUltimoMes(state) {
    try {
        const usuarioLogado = state.auth.usuarioLogado;

        const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.dashboard.filtro.id_cliente || 0;
        let competenciaBase = "";
        if (state.dashboard.filtro.mes_base == 2) {
            let dataAtual = new Date();
            dataAtual.setMonth(dataAtual.getMonth() - 2);
            competenciaBase = `&competencia_base=${dataAtual.getFullYear()}${dataAtual.getMonth() < 9 ? "0" : ""}${dataAtual.getMonth() + 1}`;
        } else {
            let dataAtual = new Date();
            dataAtual.setMonth(dataAtual.getMonth() - 1);
            competenciaBase = `&competencia_base=${dataAtual.getFullYear()}${dataAtual.getMonth() < 9 ? "0" : ""}${dataAtual.getMonth() + 1}`;
        }

        const resp = await axios.get(
            `${consts.API_URL}/fatura/listarConsumoPercentualPorHorarioUltimoMes?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}${competenciaBase}`
        );
        return resp.data;
    } catch (erro) {
        setErroAPI(erro);
    }
}
